import React, { CSSProperties } from 'react';
import { MenuItem, Select } from '@mui/material';
import { useZinantisMembers } from '../../../../contextsProperty/ContextZinantisMembers';
import Icon from '../../../../../muiComponents/Icon';
import { MembersFilters } from '../../../../../types/zinantis/members/membersType';
import useTranslate from '../../../../../customHooks/useTranslate';

interface OptionState {
    label: string;
    icon: string;
    style: CSSProperties;
    value: MembersFilters['connexion'];
}

const ConnectedFilter = () => {
    const translate = useTranslate();
    const { updateFilters, filters, zinantisStatuses } = useZinantisMembers();
    const selectStyles = {
        padding: '0 10px',
        width: '100%',
        border: '1px solid var(--border)',
        borderRadius: '5px',
        backgroundColor: 'var(--white)',

        '&::before, &::after': {
            borderBottom: 'none',
        },
        '&:hover::before': {
            borderBottom: 'none !important',
        },
        '& .MuiSelect-select': {
            paddingLeft: 0,
            display: 'flex',
            alignItems: 'center',
        },
        '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
        },
        '& .Mui-focused .MuiSelect-select': {
            backgroundColor: 'transparent',
        },
        '& .MuiInputBase-root.Mui-focused': {
            backgroundColor: 'transparent',
        },
    };

    const options: OptionState[] = [
        {
            label: translate('all'),
            icon: 'FiberManualRecordOutlined',
            style: { color: 'grey' },
            value: 'all',
        },
        ...zinantisStatuses.map(status => {
            return {
                label: translate(status.text),
                icon: 'FiberManualRecord',
                style: { color: status.color },
                value: status.key as MembersFilters['connexion'],
            };
        }),
    ];

    return (
        <Select
            className='card-component'
            variant='standard'
            placeholder={translate('connexion')}
            sx={selectStyles}
            value={filters.connexion}
        >
            {options.map((option: OptionState) => (
                <MenuItem
                    component='li'
                    key={option.label}
                    onClick={() => {
                        updateFilters('connexion', option.value);
                    }}
                    value={option.value}
                >
                    <Icon iconName={option.icon} style={option.style} />
                    <p className='margin-inline10 text-capitalize'>
                        {option.label}
                    </p>
                </MenuItem>
            ))}
        </Select>
    );
};

export default ConnectedFilter;
